import { ofType } from "redux-observable";
import { of } from "rxjs";
import { filter, retry, switchMap } from "rxjs/operators";
import { selectActiveCollectEvent } from "../../../selectors/selectCollectEvents";
import { selectOwnPlayerId } from "../../../selectors/selectPlayerInfo";
import { selectIsRankingAvailable } from "../../../selectors/selectTournamentInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { EventType } from "../../balancing/types/BalancingCore";
import { actionLeagueRankingReceived, TypeActionTournament, } from "../actionTournament";
export var epicTournamentGetCollectLeagueRankings = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionTournament.GetCollectLeagueRanking), filter(function () { return selectIsRankingAvailable(state$.value); }), filter(function () { return selectActiveCollectEvent(state$.value) != undefined; }), switchMap(function (action) {
        var eventInfo = selectActiveCollectEvent(state$.value);
        return deps
            .netSend({
            id: CommandCode.CollectLeagueRanking,
            props: {
                eventId: eventInfo.eventId,
                playerId: selectOwnPlayerId(state$.value),
            },
        })
            .pipe(retry(), switchMap(function (res) {
            return of(actionLeagueRankingReceived(res, EventType.CollectLeague));
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/epics/epicTournamentGetCollectLeagueRankings.ts
// module id = 2441
// module chunks = 3